import { Injectable } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { Config } from '../../config/config';

@Injectable()
export class AuthenticationService extends Config {
    //  _Config: Config;

    constructor(private http: Http) {
        super()
    }

    logout() {
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        sessionStorage.removeItem('accessToken');
    }

    login(emailId, password) {

        var url = this.apiEndPoint() + "validateLogin";

        var postData = {
            userid: emailId,
            password: password
        }
        var headers = new Headers({ 'Content-Type': 'application/json' });
        return this.http.post(url, postData, { headers }).map((response: Response) => {
            var res: any = response;
            var httpResponse = JSON.parse(res._body);

            console.log('API::' + url + '\n' +
                'POST DATA::' + JSON.stringify(postData) + '\n' +
                'RESPONSE::' + JSON.stringify(httpResponse));


            if (res.ok) {
                if (httpResponse.success) {

                    sessionStorage.setItem('userDetails', JSON.stringify(httpResponse.data.userDetails));
                    sessionStorage.setItem('accessToken', httpResponse.data.accessToken);
                }
                else {
                    sessionStorage.removeItem('accessToken');
                }
            }
            else {
                sessionStorage.removeItem('accessToken');
            }

            return httpResponse;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts